module.exports = __webpack_public_path__ + "static/img/frame.8b4bd28.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/frame.png
// module id = qRoL
// module chunks = 1